export default "__VITE_ASSET__D7b06NAO__"